import {z} from 'zod';
import {LabelValueSchema} from '@netx/core-next/schema';
import {DownloadOptionSchema} from '@netx/core-asset-set/schema';
import {DownloadRequestSchema} from '../downloadRequest';

export const DownloadRequestDetialsOptionSchema = DownloadOptionSchema.extend({
	linkId: z.number().int().positive(),
});

export const DownloadRequestDetailsRawSchema = DownloadRequestSchema.extend({
	approvedCount: z.number().int(),
	justification: z.record(z.string()),
	options: z.array(DownloadRequestDetialsOptionSchema),
});

export const DownloadRequestDetailsSchema =
	DownloadRequestDetailsRawSchema.omit({
		// we turn this json back into an array
		justification: true,
	}).extend({
		justification: z.array(LabelValueSchema),
	});

export const DownloadRequestCustomJustificationFormRawSchema = z.object({
	formData: z.string(),
	formName: z.literal('downloadJustification'),
	modDate: z.string(),
	modUserId: z.number().int().positive(),
});

export type IDownloadRequestDetialsOption = z.infer<
	typeof DownloadRequestDetialsOptionSchema
>;

export type IDownloadRequestDetailsRaw = z.infer<
	typeof DownloadRequestDetailsRawSchema
>;

export type IDownloadRequestDetails = z.infer<
	typeof DownloadRequestDetailsSchema
>;

export type IDownloadRequestCustomJustificationFormRaw = z.infer<
	typeof DownloadRequestCustomJustificationFormRawSchema
>;
